import styled from 'styled-components';
import { H2 } from '../../../styles/FontStyles';

import fistHubBackground from '../../../assets/images/backoffice/akasha/ahashaFistHubBackground.png';
import fistHubBackgroundMobile from '../../../assets/images/backoffice/akasha/ahashaFistHubBackgroundMobile.png';

import akasha1 from '../../../assets/images/backoffice/akasha/ahasha1.png';
import akasha2 from '../../../assets/images/backoffice/akasha/ahasha2.png';
import akasha3 from '../../../assets/images/backoffice/akasha/ahasha3.png';
import akasha4 from '../../../assets/images/backoffice/akasha/ahasha4.png';
import akasha5 from '../../../assets/images/backoffice/akasha/ahasha5.png';
import akasha6 from '../../../assets/images/backoffice/akasha/ahasha6.png';

import { Box } from '../../../styles/GlobalComponents';

export const AkashaTitle = styled.p`
  color: #000;
  font-size: 32px;
  font-weight: bold;
  margin-top: 20px;
`;

export const AkashaPackageH2 = styled(H2)`
  display: block;
  color: #3097ff;
`;

export const AkashaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 40px;
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    margin: 0;
  }
  }
`;

export const GridItem = styled(Box)<{
  selected: boolean;
}>`
  width: calc(33% - 48px);
  background-color: ${({ theme }) => theme.colors.neutral0};
  border-radius: 30px;
  padding: 20px;
  text-align: center;
  ${({ selected, theme }) =>
    selected &&
    `
      background-color: ${theme.colors.secondaryBlue};
    `}
  margin-bottom:0;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;

export const PackagesTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 140%;
  margin-top: 60px;
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #3097ff;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: #0caacd;
  margin: 34px 0;
`;

export const AkashaFirstHub = styled(Box)<{
  selected: boolean;
}>`
  display: flex;
  width: 750px;
  background: url(${fistHubBackground});
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 30px;
  padding: 30px 20px;
  text-align: center;
  margin-bottom: 0;

  @media (max-width: 1000px) {
    width: 100%;
    flex-direction: column;
    background: url(${fistHubBackgroundMobile});
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

export const MustHaveLicenceText = styled.div`
  width: 100%;
  background: #f1f1f1;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  font-weight: bold;
  padding: 30px 0;
  margin-top: 40px;
  @media (max-width: 1000px) {
    font-size: 18px;
    padding: 20px 0;
  }
`;
